import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.7 18.5">
    <path d="M0 8.9c.2-.2.3-.4.5-.6.6-.6 1.3-1.2 1.9-1.8.4-.4.8-.3 1.2 0 1.6 1.6 3.2 3.3 4.9 4.9.5.5.8.5 1.3 0C13.5 7.8 17.3 4.1 21 .3c.5-.5.9-.5 1.3 0l2 2c.1.1.2.3.4.5v.4c-.2.2-.3.4-.5.6L9.9 18.1c-.2.2-.4.3-.6.4h-.2c-.2-.1-.4-.3-.6-.4C5.9 15.4 3.3 12.7.6 10c-.3-.2-.4-.5-.6-.7v-.4z" />
  </svg>
)
